import script from "./StructureEditorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StructureEditorForm.vue?vue&type=script&setup=true&lang=js"

import "./StructureEditorForm.vue?vue&type=style&index=0&id=36d8b949&lang=css"

const __exports__ = script;

export default __exports__